import {
  appBridgeBootstrapSchema,
  createAppBridgeClient,
  type AppBridgeClient,
  type AppBridgeContext,
} from "@crewfsm/app-bridge";

export interface AutomationsAppSession {
  bridge: AppBridgeClient;
  context: AppBridgeContext;
  installationId: string;
}

export async function connectAutomationsApp(): Promise<AutomationsAppSession> {
  if (window.parent === window) {
    throw new Error("Open Automations from the CrewFSM Apps navigation.");
  }
  const bootstrap = parseBootstrap(window.name);
  const bridge = createAppBridgeClient({
    installationId: bootstrap.installationId,
    hostOrigin: parseHostOrigin(document.referrer),
    eventSource: window,
    hostWindow: window.parent,
    expectedHostWindow: window.parent,
    currentRoute: window.location.pathname || "/overview",
    clientVersion: "1.0.0",
  });
  try {
    const context = await bridge.connect();
    return { bridge, context, installationId: bootstrap.installationId };
  } catch (error) {
    bridge.destroy();
    throw error;
  }
}

export type AutomationsView =
  | { name: "OVERVIEW" }
  | { name: "WORKFLOWS" }
  | { name: "ACTIVITY" }
  | { name: "BUILDER"; workflowId: string };

export function resolveAutomationsView(currentRoute: string): AutomationsView {
  const route = currentRoute.replace(/^\/apps\/[^/]+/, "") || "/overview";
  const builder = /^\/workflows\/([^/]+)$/.exec(route);
  if (builder?.[1]) return { name: "BUILDER", workflowId: builder[1] };
  if (route.endsWith("/workflows")) return { name: "WORKFLOWS" };
  if (route.endsWith("/activity")) return { name: "ACTIVITY" };
  return { name: "OVERVIEW" };
}

function parseBootstrap(value: string) {
  try {
    return appBridgeBootstrapSchema.parse(JSON.parse(value));
  } catch {
    throw new Error("CrewFSM did not provide a valid app session bootstrap.");
  }
}

function parseHostOrigin(referrer: string): string {
  try {
    return new URL(referrer).origin;
  } catch {
    throw new Error("CrewFSM host origin is unavailable.");
  }
}
